export default "__VITE_ASSET__5WLRiiHH__"